import { Paper } from '@mui/material';
import { styled } from '@mui/system';

export const SkillCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: 'center',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease',
  background: theme.palette.mode === 'dark'
    ? (theme.custom?.glass?.bgDark || 'rgba(255, 255, 255, 0.06)')
    : 'linear-gradient(145deg, #ffffff, #f0f0f0)',
  border: theme.palette.mode === 'dark'
    ? (theme.custom?.glass?.borderDark || '1px solid rgba(255,255,255,0.10)')
    : '1px solid rgba(0,0,0,0.06)',
  backdropFilter: theme.palette.mode === 'dark' ? (theme.custom?.glass?.blur || 'blur(14px)') : undefined,
  borderRadius: '16px',
  boxShadow: theme.palette.mode === 'dark'
    ? (theme.custom?.shadows?.softDark || '0 16px 40px rgba(0, 0, 0, 0.55)')
    : '0 16px 40px rgba(0, 0, 0, 0.12)',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    background: theme.palette.mode === 'dark'
      ? (theme.custom?.gradients?.brand || 'linear-gradient(90deg, #BB86FC 0%, #03DAC6 100%)')
      : 'linear-gradient(90deg, rgba(30,60,114,0.20) 0%, rgba(42,82,152,0.20) 100%)',
    opacity: theme.palette.mode === 'dark' ? 0.10 : 0.06,
    pointerEvents: 'none',
  },
  '& > *': {
    position: 'relative',
    zIndex: 1,
  },
  '&:hover': {
    transform: 'translateY(-6px)',
    boxShadow: theme.palette.mode === 'dark'
      ? (theme.custom?.shadows?.glowPrimary || '0 0 0 1px rgba(187, 134, 252, 0.16), 0 12px 40px rgba(187, 134, 252, 0.18)')
      : '0 18px 50px rgba(0, 0, 0, 0.16)',
    borderColor: theme.palette.mode === 'dark' ? 'rgba(187, 134, 252, 0.35)' : 'rgba(30, 60, 114, 0.25)',
  },
}));

export const SkillImage = styled('img')({
  width: 50,
  height: 50,
  marginBottom: 8,
  transition: 'transform 220ms ease, filter 220ms ease',
  '&:hover': {
    transform: 'translateY(-2px) scale(1.08)',
    filter: 'drop-shadow(0 10px 18px rgba(0,0,0,0.35))',
  },
});
